<template>
  <div class="feedback-form">
    <SlideYDownTransition>
      <h6 v-if="feedbackHasBeenSent === true" class="u-txt-c u-mv">{{ customSuccesMessage }}</h6>
    </SlideYDownTransition>

    <SlideYUpTransition>
      <div v-if="feedbackHasBeenSent !== true">
        <slot name="callToAction">
          <h6 class="u-txt-c u-mv">{{ customCta }}</h6>
        </slot>

        <div class="textarea-wrapper">
          <textarea v-model="feedback" rows="2" class="textarea" :placeholder="customTextareaPlaceholder"></textarea>

          <slot name="submitButton">
            <ElButton class="inline-submit-btn" size="mini" type="text" :disabled="feedback.length === 0" @click="submitFeedback">
              Verstuur
              <i class="fas fa-chevron-right u-ml-10 u-color--tertiary" />
            </ElButton>
          </slot>
        </div>
      </div>
    </SlideYUpTransition>
  </div>
</template>

<script>
import { Button } from 'element-ui'
import { SlideYUpTransition, SlideYDownTransition } from 'vue2-transitions'
import axios from 'axios'

export default {
  name: 'FeedbackForm',

  components: {
    ElButton: Button,
    SlideYUpTransition,
    SlideYDownTransition
  },

  props: {
    customCta: {
      default: 'Was deze informatie nuttig?',
      required: false,
      type: String
    },
    customSuccesMessage: {
      default: 'Bedankt, uw feedback is verstuurd.',
      required: false,
      type: String
    },
    customTextareaPlaceholder: {
      default: 'Typ hier uw feedback...',
      required: false,
      type: String
    },
    payload: {
      default: null,
      required: false,
      type: Object
    },
    feedbackApiUrl: {
      default: '/api/faq/feedback/',
      required: false,
      type: String
    }
  },

  data() {
    return {
      feedback: '',
      feedbackHasBeenSent: false
    }
  },

  methods: {
    submitFeedback() {
      const payload = {
        municipalityId: window.municipalityId,
        feedback: this.feedback,
        ...this.payload
      }

      axios
        .post(this.feedbackApiUrl, payload)
        .then(res => {
          this.feedbackHasBeenSent = true
        })
        .catch(err => {
          throw new Error(err)
        })
    }
  }
}
</script>
